import { MainSidebar } from "@/components/sidebars/MainSidebar";
import type { ReactNode } from "react";

/** Keeps the admin sidebar alongside the teacher-shaped classroom pages it links into. */
export function AdminClassroomLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-screen">
      <MainSidebar />
      <div className="flex-1 overflow-auto">{children}</div>
    </div>
  );
}
